import { normalize } from 'normalizr';

import { notify } from 'utils/reduxUtils';

import { addOnDefSchema, variableSchema } from './entities';

export const types = {
  ADD_ON_DETAILS_PAGE_INIT: 'addOns/detailsPage/ADD_ON_DETAILS_PAGE_INIT',

  DELETE_ADD_ON_ERROR: 'addOns/detailsPage/DELETE_ADD_ON_ERROR',
  DELETE_ADD_ON_REQUEST: 'addOns/detailsPage/DELETE_ADD_ON_REQUEST',
  DELETE_ADD_ON_SUCCESS: 'addOns/detailsPage/DELETE_ADD_ON_SUCCESS',

  FORMULA_OPEN_MODAL: 'addOns/detailsPage/FORMULA_OPEN_MODAL',
  FORMULA_CLOSE_MODAL: 'addOns/detailsPage/FORMULA_CLOSE_MODAL',
  FORMULA_COMPILE_REQUEST: 'addOns/detailsPage/FORMULA_COMPILE_REQUEST',
  FORMULA_COMPILE_SUCCESS: 'addOns/detailsPage/FORMULA_COMPILE_SUCCESS',
  FORMULA_COMPILE_ERROR: 'addOns/detailsPage/FORMULA_COMPILE_ERROR',
  FORMULA_UPDATE_REQUEST: 'addOns/detailsPage/FORMULA_UPDATE_REQUEST',
  FORMULA_UPDATE_SUCCESS: 'addOns/detailsPage/FORMULA_UPDATE_SUCCESS',
  FORMULA_UPDATE_ERROR: 'addOns/detailsPage/FORMULA_UPDATE_ERROR',
  FORMULA_RESET_MESSAGE: 'addOns/detailsPage/FORMULA_RESET_MESSAGE',

  RECEIVE_ADD_ON: 'addOns/detailsPage/RECEIVE_ADD_ON',

  UPDATE_ADD_ON_ERROR: 'addOns/detailsPage/UPDATE_ADD_ON_ERROR',
  UPDATE_ADD_ON_REQUEST: 'addOns/detailsPage/UPDATE_ADD_ON_REQUEST',
  UPDATE_ADD_ON_SUCCESS: 'addOns/detailsPage/UPDATE_ADD_ON_SUCCESS',

  UPDATE_VARIABLE_ERROR: 'addOns/detailsPage/UPDATE_VARIABLE_ERROR',
  UPDATE_VARIABLE_REQUEST: 'addOns/detailsPage/UPDATE_VARIABLE_REQUEST',
  UPDATE_VARIABLE_SUCCESS: 'addOns/detailsPage/UPDATE_VARIABLE_SUCCESS',
};

export const addOnDetailsPage = {
  init: () => ({
    type: types.ADD_ON_DETAILS_PAGE_INIT,
  }),
};

export const deleteAddOn = {
  error: notify(
    (error) => ({
      type: types.DELETE_ADD_ON_ERROR,
      payload: error,
    }),
    'Failed to delete add-on',
  ),
  request: () => ({
    type: types.DELETE_ADD_ON_REQUEST,
  }),
  success: notify(
    () => ({
      type: types.DELETE_ADD_ON_SUCCESS,
    }),
    'Successfully deleted add-on',
  ),
};

export const entities = {
  receiveAddOn: ({ addOn }) => ({
    type: types.RECEIVE_ADD_ON,
    payload: normalize(addOn, addOnDefSchema),
  }),
};

export const formulaEdit = {
  openModal: () => ({
    type: types.FORMULA_OPEN_MODAL,
  }),
  closeModal: () => ({
    type: types.FORMULA_CLOSE_MODAL,
  }),
  compileRequest: ({ formula }) => ({
    type: types.FORMULA_COMPILE_REQUEST,
    payload: { formula },
  }),
  compileSuccess: () => ({
    type: types.FORMULA_COMPILE_SUCCESS,
  }),
  compileError: ({ error }) => ({
    type: types.FORMULA_COMPILE_ERROR,
    payload: { error },
  }),
  updateRequest: ({ formula, revertedFrom }) => ({
    type: types.FORMULA_UPDATE_REQUEST,
    payload: { formula, revertedFrom },
  }),
  updateSuccess: ({ formula }) => ({
    type: types.FORMULA_UPDATE_SUCCESS,
    payload: { formula },
  }),
  updateError: ({ error }) => ({
    type: types.FORMULA_UPDATE_ERROR,
    payload: { error },
  }),
  resetFormulaMessage: () => ({
    type: types.FORMULA_RESET_MESSAGE,
  }),
};

export const updateAddOn = {
  error: notify(
    (error) => ({
      type: types.UPDATE_ADD_ON_ERROR,
      payload: error,
    }),
    'Failed to save Add-On',
  ),
  request: ({ addOnId, data }) => ({
    type: types.UPDATE_ADD_ON_REQUEST,
    payload: { addOnId, data },
  }),
  success: ({ addOn }) => ({
    type: types.UPDATE_ADD_ON_SUCCESS,
    payload: normalize(addOn, addOnDefSchema),
  }),
};

export const updateVariable = {
  error: notify(
    (error) => ({
      type: types.UPDATE_VARIABLE_ERROR,
      payload: error,
    }),
    'Failed to save pricing input',
  ),
  request: ({ variableId, data }) => ({
    type: types.UPDATE_VARIABLE_REQUEST,
    payload: { variableId, data },
  }),
  success: ({ variable }) => ({
    type: types.UPDATE_VARIABLE_SUCCESS,
    payload: normalize(variable, variableSchema),
  }),
};
